
(function (window, document, jQuery, undefined) {
    
    $('.kit-navbar__searchfield--autocomplete').autocomplete({
        serviceUrl: '/' + window.conkit_culture +'/SearchPage/Suggest',
        minChars: 3,
        params: {
            searchindex: "" + window.conkit_searchindex
        }
    });

})(window, document, jQuery);
